var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deck",class:{ 'columns-3': _vm.cols3, 'columns-4': _vm.cols4, 'columns-5': _vm.cols5 }},_vm._l((_vm.cards),function(card){return _c('Card',{key:card.id,style:({ fontFamily: _vm.font }),attrs:{"item":card}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }